module.exports = __webpack_public_path__ + "img/workers.4acdfae7.jpg";